import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import env from "./configs/env/config.js";
import configAdmin from "./configs/admin.js";
import configFe from "./configs/fe.js";
import helpers from "./helpers/index.js";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import Loading from "vue-loading-overlay";

import {
  faStar,
  faChevronRight,
  faChevronLeft,
  faTimes,
  faArrowLeft,
  faTimesCircle,
  faPlusCircle,
  faMinusCircle,
  faAngleDown,
  faAngleUp,
} from "@fortawesome/free-solid-svg-icons";

import { ValidationProvider, ValidationObserver } from "vee-validate";
const moment = require("moment");
import "./helpers/validate";
import oncreated from "@/store/oncreated";
import "@/helpers/filters";

Vue.config.productionTip = false;

import Default from "@/layouts/Default";
import Admin from "@/layouts/Admin";
import Empty from "@/layouts/Empty";
import Constant from "@/configs/constant";
library.add(
  faChevronRight,
  faChevronLeft,
  faStar,
  faTimes,
  faArrowLeft,
  faTimesCircle,
  faPlusCircle,
  faMinusCircle,
  faAngleDown,
  faAngleUp
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("default-layout", Default);
Vue.component("admin-layout", Admin);
Vue.component("empty-layout", Empty);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.use(VueAwesomeSwiper);

Vue.prototype.$constant = Constant;

import i18n from "./lang/admin/i18n";
moment.locale(i18n.locale);
Vue.use(require("vue-moment"), {
  moment,
});

import VueCookies from "vue-cookies";
Vue.use(VueCookies);

import VueHead from 'vue-head';
Vue.use(VueHead);

Vue.prototype.$env = env;
Vue.prototype.$configAdmin = configAdmin;
Vue.prototype.$configFe = configFe;
Vue.prototype.$helper = helpers;
// set default lang for html
document.documentElement.setAttribute("lang", "ja");

Vue.use(Loading);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
  created() {
    oncreated.init();
  },
}).$mount("#app");
